import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const ErrorMessage = props => {
    const { isVisible = false, messageText = false, textReplacements, errorWrapperClasses, errorClasses } = props;

    return isVisible ? (
        <div className={`${errorWrapperClasses ? errorWrapperClasses.join(' ') : ''}`}>
            <span
                className={`${isVisible ? 'shown' : 'hidden'} error--msg ${errorClasses ? errorClasses.join(' ') : ''}`}
            >
                <em>
                    <FontAwesomeIcon icon="exclamation" />
                </em>
                <FormattedMessage
                    id={messageText === false ? 'common.no_text' : messageText}
                    values={{ 
                        text: textReplacements,
                        br: <br/>,
                        strong: chunks => <strong>{chunks}</strong>
                    }}
                />
            </span>
        </div>
    ) : null;
};

export default ErrorMessage;
